import React from 'react'
import { Service } from '@/payload-types'
import { GridBlock } from '@/components'

interface ServiceListProps {
  items: Service[]
}

function ServiceList({ items }: Readonly<ServiceListProps>) {
  if (items.length === 0) return null

  return (
    <GridBlock
      blockType="grid"
      items={items.map((service) => ({
        relationTo: 'services' as const,
        value: service,
      }))}
    />
  )
}

export { ServiceList }
